import type { PerformancePart } from '@tunasong/schemas'
import { normalizeParts, performancePartLabels } from '@tunasong/schemas'

/** Input-list order by stage convention: drums first, vocals last, horns and anything unknown between keys and vocals */
export const stageBuckets = ['drums', 'bass', 'guitar', 'keys', 'other', 'vocals'] as const
const otherBucket = stageBuckets.indexOf('other')

export const stageBucket = (part: string | undefined) => {
  const index = stageBuckets.findIndex(bucket => bucket === part)
  return index === -1 ? otherBucket : index
}

const clean = (value?: string) => value?.trim() || undefined

/**
 * The rider's role text: the parts the member plays (never Full chart, which is not an instrument), then their Other
 * instruments. The old free-text role is used only when neither exists.
 */
export const riderRoleLabel = (parts: readonly string[] | undefined, other?: string, legacyRole?: string) => {
  const labels = (normalizeParts(parts) ?? [])
    .filter((part): part is Exclude<PerformancePart, 'full'> => part !== 'full')
    .map(part => performancePartLabels[part])
  const all = [...labels, clean(other)].filter((label): label is string => Boolean(label))
  return all.length > 0 ? all.join(' + ') : clean(legacyRole)
}
